import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable, finalize } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpRespuesta } from '../models/http-respuesta.interface';
import { TotalesGenerales, SaldoMedicoGeneral, SaldoEnfermeraGeneral } from '../models/totales-generales.interface';
import { LoaderService } from '../shared/loader/services/loader.service';
import { HttpPaginacion } from '../models/http-paginacion.interface';
import { SupevisorPage, MedicoPage, CasoClinicoPage, EnfermeraPage, ProoductoPage, HospitalPage, InstitucionPage, CatalogoPage, PuntoPage } from '../models/entidad-page.interface';
import { UsuarioSesion } from '../models/usuario-sesion.interface';
import { CasoClinico } from '../models/caso-clinico.interface';
import { Medico } from '../models/medico.interface';
import { Enfermera } from '../models/enfermera.interface';
import { Supervisor } from '../models/supervisor.interface';
import { DocumentoCasoClinico } from '../models/documento-caso-clinico.interface';
import { CanjeEnfermera } from '../models/canje-enfermera';
import { CanjeMedico } from '../models/canje-medico';
import { RedimirEnfermera, RedimirMedico, RedimirReferencia, RedimirSupervisor } from '../models/redimir.interface';
import { Institucion } from '../models/institucion.interface';
import { Hospital } from '../models/hospital.interface';
import { Estado } from '../models/estado.interface';
import { Catalogo, Puntos } from '../models/catalogos.interface';
import { InformeProductoCuerpo } from '../models/informe-producto-cuerpo';
import { InformeProductoInstitucion } from '../models/informe-producto-institucion';
import { InformeProductoHospital } from '../models/informe-producto-hospital';
import { Especialidad } from '../models/especialidad.interface';
import { NuevoUsuarioAlta } from '../models/nuevo-usuario.interface';
import { Distribuidor } from '../models/distribuidor.interface';
import { Producto } from '../models/producto.interface';
import { BusqCasosclinico, BusqEnfermera, BusqProducto, BusqUsuario, HttpPaginacionBusqueda } from '../models/http-paginacion-busqueda.interface';
import { map } from 'rxjs';
import { InformeCanjeMedico } from '../models/informe-canjes-medicos.interface';

const httpOptions = {
  headers: new HttpHeaders({

    'Cache-Control': 'no-cache',
    'Pragma': 'no-cache',
  })
};
@Injectable({
  providedIn: 'root'
})
export class AdministradorService {

  constructor(private httpclient: HttpClient, private loaderService: LoaderService) { }

  totales(): Observable<TotalesGenerales> {
    this.loaderService.activar();
    return this.httpclient.get<TotalesGenerales>(environment.api.totales, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }

  desactivarUsuario(id: number): Observable<HttpRespuesta<UsuarioSesion>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpRespuesta<UsuarioSesion>>(environment.api.desactivarUsuario + id.toString(), httpOptions).pipe(finalize(() => this.loaderService.desactivar()))
  }

  activarUsuario(id: number): Observable<HttpRespuesta<UsuarioSesion>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpRespuesta<UsuarioSesion>>(environment.api.activarUsuario + id.toString(), httpOptions).pipe(finalize(() => this.loaderService.desactivar()))
  }

  medicos(page: number): Observable<HttpPaginacion<MedicoPage>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpPaginacion<MedicoPage>>(environment.api.medicos + `?page=${page}`, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }

  casosclinicos(page: number): Observable<HttpPaginacion<CasoClinicoPage>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpPaginacion<CasoClinicoPage>>(environment.api.casosclinicos + `?page=${page}`, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }

  enfermeras(page: number): Observable<HttpPaginacion<EnfermeraPage>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpPaginacion<EnfermeraPage>>(environment.api.enfermeras + `?page=${page}`, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }

  getLogs(page: number = 1): Observable<any> {
    this.loaderService.activar();

    return this.httpclient
      .get<any>(environment.api.logs + `?page=${page}`)
      .pipe(
        map(response => {
          // El backend devuelve { success: true, data: { data: [...], last_page: ... } }
          console.log('Servicio - Respuesta original:', response);
          if (response && response.success && response.data) {
            return response.data; // Retorna solo { data: [...], last_page: ... }
          }
          return response;
        }),
        finalize(() => this.loaderService.desactivar())
      );
  }

  busquedaUsuarios(filters: { nombre?: string }, page = 1): Observable<HttpPaginacionBusqueda<BusqUsuario>> {
    let params = new HttpParams().set('page', page);
    let headers = httpOptions.headers;
    Object.entries(filters).forEach(([k, v]) => {
      if (v != null && v !== '') {
        params = params.set(k, v.toString());
      }
    });
    this.loaderService.activar();

    return this.httpclient.get<HttpPaginacionBusqueda<BusqUsuario>>(environment.api.busquedausuario, { headers, params }).pipe(finalize(() => this.loaderService.desactivar()));
  }

  busquedaEnfermeras(filters: { nombre?: string, apellido_paterno?: string, apellido_materno?: string }, page = 1): Observable<HttpPaginacionBusqueda<BusqUsuario>> {
    let params = new HttpParams().set('page', page);
    let headers = httpOptions.headers;
    Object.entries(filters).forEach(([k, v]) => {
      if (v != null && v !== '') {
        params = params.set(k, v.toString());
      }
    });

    this.loaderService.activar();
    return this.httpclient.get<HttpPaginacionBusqueda<BusqUsuario>>(environment.api.busquedaenfermera, { headers, params }).pipe(finalize(() => this.loaderService.desactivar()));
  }

  busquedaMedicos(filters: { nombre?: string, apellido_paterno?: string, apellido_materno?: string }, page = 1): Observable<HttpPaginacionBusqueda<BusqUsuario>> {
    let params = new HttpParams().set('page', page);
    let headers = httpOptions.headers;
    Object.entries(filters).forEach(([k, v]) => {
      if (v != null && v !== '') {
        params = params.set(k, v.toString());
      }
    });
    this.loaderService.activar();
    return this.httpclient.get<HttpPaginacionBusqueda<BusqUsuario>>(environment.api.busquedamedico, { headers, params }).pipe(finalize(() => this.loaderService.desactivar()));
  }

  busquedaSupervisores(filters: { nombre?: string, apellido_paterno?: string, apellido_materno?: string }, page = 1): Observable<HttpPaginacionBusqueda<BusqUsuario>> {
    let params = new HttpParams().set('page', page);
    let headers = httpOptions.headers;
    Object.entries(filters).forEach(([k, v]) => {
      if (v != null && v !== '') {
        params = params.set(k, v.toString());
      }
    });
    this.loaderService.activar();
    return this.httpclient.get<HttpPaginacionBusqueda<BusqUsuario>>(environment.api.busquedasupervisor, { headers, params }).pipe(finalize(() => this.loaderService.desactivar()));
  }

  busquedaCasosClincos(filters: { nombre?: string, apellido_paterno?: string, apellido_materno?: string }, page = 1): Observable<HttpPaginacionBusqueda<BusqCasosclinico>> {
    let params = new HttpParams().set('page', page);
    let headers = httpOptions.headers;
    Object.entries(filters).forEach(([k, v]) => {
      if (v != null && v !== '') {
        params = params.set(k, v.toString());
      }
    });
    this.loaderService.activar();
    return this.httpclient.get<HttpPaginacionBusqueda<BusqCasosclinico>>(environment.api.busquedacasoclinico, { headers, params }).pipe(finalize(() => this.loaderService.desactivar()));
  }

  buscarProductos(filters: { codigo?: string; }, page = 1): Observable<HttpPaginacionBusqueda<BusqProducto>> {
    let params = new HttpParams().set('page', page);
    let headers = httpOptions.headers;
    Object.entries(filters).forEach(([k, v]) => {
      if (v != null && v !== '') {
        params = params.set(k, v.toString());
      }
    });
    this.loaderService.activar();
    return this.httpclient.get<HttpPaginacionBusqueda<BusqProducto>>(environment.api.busquedaproducto, { headers, params }).pipe(finalize(() => this.loaderService.desactivar()));
  }

  supervisores(page: number): Observable<HttpPaginacion<SupevisorPage>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpPaginacion<SupevisorPage>>(environment.api.supervisores + `?page=${page}`, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }

  distribuidores(page: number): Observable<HttpPaginacion<Distribuidor>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpPaginacion<Distribuidor>>(environment.api.distribuidores + `?page=${page}`).pipe(finalize(() => { this.loaderService.desactivar() }))
  }

  usuarios(page: number): Observable<HttpPaginacion<UsuarioSesion>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpPaginacion<UsuarioSesion>>(environment.api.usuarios + `?page=${page}`, httpOptions).pipe(finalize(() => { this.loaderService.desactivar() }))
  }

  productos(page: number): Observable<HttpPaginacion<ProoductoPage>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpPaginacion<ProoductoPage>>(environment.api.productos + `?page=${page}`, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }

  hospitales(page: number): Observable<HttpPaginacion<HospitalPage>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpPaginacion<HospitalPage>>(environment.api.hospitales + `?page=${page}`, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }

  instituciones(page: number): Observable<HttpPaginacion<InstitucionPage>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpPaginacion<InstitucionPage>>(environment.api.instituciones + `?page=${page}`, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }

  diagnosticos(page: number): Observable<HttpPaginacion<CatalogoPage>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpPaginacion<CatalogoPage>>(environment.api.diagnosticos + `?page=${page}`, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }

  puntos(page: number): Observable<HttpPaginacion<PuntoPage>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpPaginacion<PuntoPage>>(environment.api.puntos + `?page=${page}`, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }

  antibioticos(page: number): Observable<HttpPaginacion<CatalogoPage>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpPaginacion<CatalogoPage>>(environment.api.antibioticos + `?page=${page}`, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }

  getCasoClinico(id: string): Observable<HttpRespuesta<CasoClinico>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpRespuesta<CasoClinico>>(environment.api.casosclinicos + '/' + id, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }

  getMedico(id: string): Observable<HttpRespuesta<Medico>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpRespuesta<Medico>>(environment.api.medicos + '/' + id, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }

  // getEnfermera(id: string): Observable<HttpRespuesta<Enfermera>> {
  //   this.loaderService.activar();
  //   return this.httpclient.get<HttpRespuesta<Enfermera>>(environment.api.enfermeras + '/' + id).pipe(finalize(() => this.loaderService.desactivar()));
  // }
  getEnfermera(id: string): Observable<HttpRespuesta<Enfermera>> {
    this.loaderService.activar();
    return this.httpclient.get<any>(environment.api.enfermeras + '/' + id, httpOptions).pipe(
      map((respuesta: any) => {
        // Si la respuesta tiene la estructura anidada
        if (respuesta.datos && respuesta.datos.enfermera) {
          return {
            ...respuesta,
            datos: respuesta.datos.enfermera  // Extrae la enfermera anidada
          };
        }
        return respuesta;
      }),
      finalize(() => this.loaderService.desactivar())
    );
  }

  getSupervisor(id: string): Observable<HttpRespuesta<Supervisor>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpRespuesta<Supervisor>>(environment.api.supervisores + '/' + id, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }

  getProducto(id: string): Observable<HttpRespuesta<Producto>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpRespuesta<Producto>>(environment.api.productos + '/' + id, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }

  puntosysaldosMedicos(): Observable<SaldoMedicoGeneral[]> {
    this.loaderService.activar();
    return this.httpclient.get<SaldoMedicoGeneral[]>(environment.api.puntosysaldosmedicos, httpOptions).pipe(finalize(() => this.loaderService.desactivar()))
  }

  puntosysaldosEnfermeras(): Observable<SaldoEnfermeraGeneral[]> {
    this.loaderService.activar();
    return this.httpclient.get<SaldoEnfermeraGeneral[]>(environment.api.puntosysaldosenfermeras, httpOptions).pipe(finalize(() => this.loaderService.desactivar()))
  }

  elimiarDocumento(id: number): Observable<HttpRespuesta<DocumentoCasoClinico[]>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpRespuesta<DocumentoCasoClinico[]>>(environment.api.eliminarDocumentoCasoClinico + id.toString(), httpOptions).pipe(finalize(() => this.loaderService.desactivar()))
  }

  getRedimirMedicoAtender(id: string): Observable<HttpRespuesta<RedimirMedico>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpRespuesta<RedimirMedico>>(environment.api.redimirMedicoAtender + id, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }

  getRedimirEnfermeraAtender(id: string): Observable<HttpRespuesta<RedimirEnfermera>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpRespuesta<RedimirEnfermera>>(environment.api.redimirEnfermeraAtender + id, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }

  getRedimirSupervisorAtender(id: string): Observable<HttpRespuesta<RedimirSupervisor>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpRespuesta<RedimirSupervisor>>(environment.api.redimirSupervisorAtender + id, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }

  setRedimirMedicoAceptar(redimirFD: FormData): Observable<HttpRespuesta<RedimirMedico>> {
    this.loaderService.activar();
    return this.httpclient.post<HttpRespuesta<RedimirMedico>>(environment.api.redimirMedicoAceptar, redimirFD, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  setCanjeMedicoAceptar(redimirFD: FormData): Observable<HttpRespuesta<RedimirMedico>> {
    this.loaderService.activar();
    return this.httpclient.post<HttpRespuesta<RedimirMedico>>(environment.api.canjeMedicoAceptar, redimirFD, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  setRedimirEnfermeraAceptar(redimirFD: FormData): Observable<HttpRespuesta<RedimirEnfermera>> {
    this.loaderService.activar();
    return this.httpclient.post<HttpRespuesta<RedimirEnfermera>>(environment.api.redimirEnfermeraAceptar, redimirFD, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  setRedimirSupervisorAceptar(redimirFD: FormData): Observable<HttpRespuesta<RedimirSupervisor>> {
    this.loaderService.activar();
    return this.httpclient.post<HttpRespuesta<RedimirSupervisor>>(environment.api.redimirSupervisorAceptar, redimirFD, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  setRedimirMedicoRechazar(redimirFD: FormData): Observable<HttpRespuesta<RedimirMedico>> {
    this.loaderService.activar();
    return this.httpclient.post<HttpRespuesta<RedimirMedico>>(environment.api.redimirMedicoRechazar, redimirFD, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  setRedimirEnfermeraRechazar(redimirFD: FormData): Observable<HttpRespuesta<RedimirEnfermera>> {
    this.loaderService.activar();
    return this.httpclient.post<HttpRespuesta<RedimirEnfermera>>(environment.api.redimirEnfermeraRechazar, redimirFD, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  setRedimirSupervisorRechazar(redimirFD: FormData): Observable<HttpRespuesta<RedimirSupervisor>> {
    this.loaderService.activar();
    return this.httpclient.post<HttpRespuesta<RedimirSupervisor>>(environment.api.redimirSupervisorRechazar, redimirFD, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  setRedimirEnfermeraCancelar(redimirFD: FormData): Observable<HttpRespuesta<RedimirEnfermera>> {
    this.loaderService.activar();
    return this.httpclient.post<HttpRespuesta<RedimirEnfermera>>(environment.api.redimirEnfermeraCancelar, redimirFD, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  setRedimirSupervisorCancelar(redimirFD: FormData): Observable<HttpRespuesta<RedimirSupervisor>> {
    this.loaderService.activar();
    return this.httpclient.post<HttpRespuesta<RedimirSupervisor>>(environment.api.redimirSupervisorCancelar, redimirFD, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  setRedimirMedicoObservacion(redimirFD: FormData): Observable<HttpRespuesta<RedimirMedico>> {
    this.loaderService.activar();
    return this.httpclient.post<HttpRespuesta<RedimirMedico>>(environment.api.redimirMedicoObservacion, redimirFD, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  setRedimirEnfermeraObservacion(redimirFD: FormData): Observable<HttpRespuesta<RedimirEnfermera>> {
    this.loaderService.activar();
    return this.httpclient.post<HttpRespuesta<RedimirEnfermera>>(environment.api.redimirEnfermeraObservacion, redimirFD, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  setRedimirSupervisorObservacion(redimirFD: FormData): Observable<HttpRespuesta<RedimirSupervisor>> {
    this.loaderService.activar();
    return this.httpclient.post<HttpRespuesta<RedimirSupervisor>>(environment.api.redimirSupervisorObservacion, redimirFD, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  addRedimirMedicoDocumento(redimirFD: FormData): Observable<HttpRespuesta<RedimirMedico>> {
    this.loaderService.activar();
    return this.httpclient.post<HttpRespuesta<RedimirMedico>>(environment.api.agregarDocumentoRedimirMedico, redimirFD, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  addRedimirEnfermeraDocumento(redimirFD: FormData): Observable<HttpRespuesta<RedimirEnfermera>> {
    this.loaderService.activar();
    return this.httpclient.post<HttpRespuesta<RedimirEnfermera>>(environment.api.agregarDocumentoRedimirEnfermera, redimirFD, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  addRedimirSupervisorDocumento(redimirFD: FormData): Observable<HttpRespuesta<RedimirSupervisor>> {
    this.loaderService.activar();
    return this.httpclient.post<HttpRespuesta<RedimirSupervisor>>(environment.api.agregarDocumentoRedimirSupervisor, redimirFD, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  quitarRedimirMedicoDocumento(id: number): Observable<HttpRespuesta<RedimirReferencia[]>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpRespuesta<RedimirReferencia[]>>(environment.api.eliminarDocumentoRedimirMedico + id.toString(), httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  quitarRedimirEnfermeraDocumento(id: number): Observable<HttpRespuesta<RedimirReferencia[]>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpRespuesta<RedimirReferencia[]>>(environment.api.eliminarDocumentoRedimirEnfermera + id.toString(), httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  quitarRedimirSupervisorDocumento(id: number): Observable<HttpRespuesta<RedimirReferencia[]>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpRespuesta<RedimirReferencia[]>>(environment.api.eliminarDocumentoRedimirSupervisor + id.toString(), httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  setInstitucion(institucion: Institucion): Observable<HttpRespuesta<Institucion>> {
    this.loaderService.activar();
    return this.httpclient.post<HttpRespuesta<Institucion>>(environment.api.instituciones, institucion, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  setHospital(hospital: Hospital): Observable<HttpRespuesta<Hospital>> {
    this.loaderService.activar();
    return this.httpclient.post<HttpRespuesta<Hospital>>(environment.api.hospitales, hospital, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  getCatalogoInstituciones(): Observable<Institucion[]> {
    this.loaderService.activar();
    return this.httpclient.get<Institucion[]>(environment.api.catalogoIntituciones, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  getCatalogoEstados(): Observable<Estado[]> {
    this.loaderService.activar();
    return this.httpclient.get<Estado[]>(environment.api.catalogoEntidadesFederativa, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  setDiagnostico(catalogo: Catalogo): Observable<HttpRespuesta<Catalogo>> {
    this.loaderService.activar();
    return this.httpclient.post<HttpRespuesta<Catalogo>>(environment.api.diagnosticos, catalogo, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  setAntibiotico(catalogo: Catalogo): Observable<HttpRespuesta<Catalogo>> {
    this.loaderService.activar();
    return this.httpclient.post<HttpRespuesta<Catalogo>>(environment.api.antibioticos, catalogo, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  setPuntos(catalogo: Puntos): Observable<HttpRespuesta<Puntos>> {
    this.loaderService.activar();
    return this.httpclient.post<HttpRespuesta<Puntos>>(environment.api.puntos, catalogo, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  catalogoPuntos(): Observable<Puntos[]> {
    this.loaderService.activar();
    return this.httpclient.get<Puntos[]>(environment.api.catalogoPuntos, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  asignarPuntosCasoClinico(idCasoClinico: number, e_puntos: number): Observable<HttpRespuesta<CasoClinico>> {
    this.loaderService.activar();
    return this.httpclient.put<HttpRespuesta<CasoClinico>>(environment.api.asignarpuntoscasoclinico + idCasoClinico, { e_puntos }, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  asignarPuntosCasoClinicoSupervisor(idCasoClinico: number, s_puntos: number): Observable<HttpRespuesta<CasoClinico>> {
    this.loaderService.activar();
    return this.httpclient.put<HttpRespuesta<CasoClinico>>(environment.api.asignarpuntoscasoclinico + idCasoClinico, { s_puntos }, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  asignarMedicoPuntosDefault(idMedico: number, puntos: Puntos): Observable<HttpRespuesta<CasoClinico>> {
    this.loaderService.activar();
    return this.httpclient.put<HttpRespuesta<CasoClinico>>(environment.api.asignarmedicopuntosdefault + idMedico, puntos, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  asignarPuntosProducto(asignar: { fk_producto: number, puntos: number }): Observable<HttpRespuesta<Producto>> {
    this.loaderService.activar();
    return this.httpclient.post<HttpRespuesta<Producto>>(environment.api.asignarpuntosproducto, asignar, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  asociarEnfermeraCasoClinico(fk_enfermera: number, fk_casoclinico: number): Observable<HttpRespuesta<CasoClinico>> {
    this.loaderService.activar();
    return this.httpclient.post<HttpRespuesta<CasoClinico>>(environment.api.asigacionEnfermeraCasoClinico, { fk_enfermera, fk_casoclinico }, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  notificacionesCanjesEnfermeras(): Observable<HttpRespuesta<CanjeEnfermera[]>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpRespuesta<CanjeEnfermera[]>>(environment.api.notificacionesCanjesEnfermeras, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  notificacionesCanjesMedicos(): Observable<HttpRespuesta<CanjeMedico[]>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpRespuesta<CanjeMedico[]>>(environment.api.notificacionesCanjesMedicos, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  informeProductosHospitales(): Observable<HttpRespuesta<InformeProductoHospital[]>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpRespuesta<InformeProductoHospital[]>>(environment.api.informeProductosCategoriaHospital, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  informeProductosInstituciones(): Observable<HttpRespuesta<InformeProductoInstitucion[]>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpRespuesta<InformeProductoInstitucion[]>>(environment.api.informeProductosCategoriaInstitucion, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  informeProductosCuerpo(): Observable<HttpRespuesta<InformeProductoCuerpo[]>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpRespuesta<InformeProductoCuerpo[]>>(environment.api.informeProductosCategoriaCuerpo, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  getEspecialidades(): Observable<Especialidad[]> {
    return this.httpclient.get<Especialidad[]>(environment.api.catalogos + 'especialidades');
  }
  getPuestos(): Observable<Catalogo[]> {
    return this.httpclient.get<Catalogo[]>(environment.api.catalogos + 'puestos');
  }
  getHospitales(fk_institucion: number | null, fk_estado: number | null): Observable<Hospital[]> {
    return this.httpclient.post<Hospital[]>(environment.api.catalogos + 'hospitales', { fk_institucion, fk_estado });
  }
  getInstituciones(): Observable<Institucion[]> {
    return this.httpclient.get<Institucion[]>(environment.api.catalogos + 'instituciones');
  }
  getEstados(): Observable<Estado[]> {
    return this.httpclient.get<Estado[]>(environment.api.catalogos + 'estados');
  }
  getPuntos(): Observable<Puntos[]> {
    return this.httpclient.get<Puntos[]>(environment.api.catalogos + 'puntos');
  }
  getRoles(): Observable<Catalogo[]> {
    return this.httpclient.get<Catalogo[]>(environment.api.catalogos + 'roles');
  }
  getNiveles(): Observable<Catalogo[]> {
    return this.httpclient.get<Catalogo[]>(environment.api.catalogos + 'niveles');
  }
  getRolesPrincipales(): Observable<Catalogo[]> {
    return this.httpclient.get<Catalogo[]>(environment.api.catalogos + 'roles/principales');
  }
  getDistribuidores(): Observable<Distribuidor[]> {
    return this.httpclient.get<Distribuidor[]>(environment.api.catalogos + 'distribuidores');
  }
  setNuevoUsuario(nuevousuario: NuevoUsuarioAlta): Observable<HttpRespuesta<UsuarioSesion>> {
    this.loaderService.activar();
    return this.httpclient.post<HttpRespuesta<UsuarioSesion>>(environment.api.nuevousuario, nuevousuario, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  updateUsuario(idUsuario: number, usuario: NuevoUsuarioAlta): Observable<HttpRespuesta<UsuarioSesion>> {
    this.loaderService.activar();
    return this.httpclient.put<HttpRespuesta<UsuarioSesion>>(environment.api.actualizarusuario + idUsuario, usuario, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  setNuevoDistribuidor(distribuidor: Distribuidor): Observable<any> {
    this.loaderService.activar();
    return this.httpclient.post<any>(environment.api.nuevodistribudor, distribuidor, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  asignarDistribuidorAlaEnfermera(asignar: { fk_enfermera: string, fk_distribuidor: string }): Observable<HttpRespuesta<Enfermera>> {
    this.loaderService.activar();
    return this.httpclient.post<HttpRespuesta<Enfermera>>(environment.api.asignarenfermeradistribuidor, asignar, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  setCambiarPassword(id: number, nuevo_password: string): Observable<HttpRespuesta<UsuarioSesion>> {
    this.loaderService.activar();
    return this.httpclient.put<HttpRespuesta<UsuarioSesion>>(environment.api.cambiarpassword + id, { nuevo_password }, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
  updateProducto(id: string, status: number, motivo?: string): Observable<HttpRespuesta<Producto>> {
    this.loaderService.activar();
    const body: any = { status };
    if (typeof motivo !== 'undefined' && motivo !== null) {
      body.motivo = motivo;
    }
    return this.httpclient.put<HttpRespuesta<Producto>>(environment.api.productos + '/' + id, body, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }

  getInfoCanjesMedicos(): Observable<HttpRespuesta<InformeCanjeMedico[]>> {
    this.loaderService.activar();
    return this.httpclient.get<HttpRespuesta<InformeCanjeMedico[]>>(environment.api.informeCanjesMedicos, httpOptions).pipe(finalize(() => this.loaderService.desactivar()));
  }
}
